import { Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] py-8 sm:py-12 px-4 border-t border-white/10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Left column */}
        <div className="space-y-4 text-center md:text-left">
          <h3 className="text-2xl font-normal text-white">auryx</h3>
          <p className="text-white/60">
            Turning ordinary earbuds into<br />health sensors using AI
          </p>
        </div>
        
        {/* Middle column - centered */}
        <div className="space-y-4 text-center">
          <h4 className="font-semibold text-white">Contact</h4>
          <address className="not-italic text-white/60">
            Cambridge,<br />
            United Kingdom<br />
            <a href="mailto:contact@auryx.ai" className="hover:text-[#ffa05d] transition-colors">
              contact@auryx.ai
            </a>
          </address>
        </div>
        
        {/* Right column - aligned to the right */}
        <div className="space-y-4 text-center md:text-right">
          <h4 className="font-semibold text-white">Connect</h4>
          <a 
            href="https://www.linkedin.com/company/auryxai" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-white/60 hover:text-[#ffa05d] transition-colors justify-center md:justify-end"
          >
            <Linkedin size={20} />
            <span>LinkedIn</span>
          </a>
        </div>
      </div>
      
      <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-white/10 text-center text-white/40 text-sm">
        <p>© 2026 Auryx AI Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};
